import { dateValueFormatter } from '../utils/format-date-cell';


export let colBaaNum = {colId: 'baaNum', headerName: 'Number', field: 'baaNum',width: 100, sortable: true};
export let colBaaId = {colId: 'baaId', headerName: 'ID', field: 'baaId',width: 100, sortable: true};

export let colMainDocumentName = {
  colId: 'mainDocumentName',
  headerName: 'Main Document Name',
  field: 'mainDocumentName',
  width: 150,
  sortable: true,
  filter: true
};

export let colBusinessAssociateName = {
                                        colId: 'businessAssociateName',
                                        headerName: 'Business Associate Name',
                                        field: 'businessAssociateName.name',
                                        width: 100,
                                        sortable: true
                                      };
                                      
export let colBusinessAssociateNotification = { colId: 'businessAssociateNotification',
                                                headerName: 'Business Associate Notification',
                                                field: 'businessAssociateNotification.fullName',
                                                width: 100,
                                                sortable: true
                                              };
export let colParty = {
                        colId: 'partyFriendlyName',
                        headerName: 'Party',
                        field: 'party',
                        width: 100,
                        sortable: true,
                        valueGetter: (params: any) => {
                          const party = params.data?.party;
                          if (!party) return '';
                          if (typeof party === 'string') return party;
                          if (typeof party === 'object') return party.name || '';
                          return '';
                        }
                      };
export let colTypeOfService = {colId: 'typeOfService',
                                headerName: 'BAA Contract Type',
                                field: 'typesOfService',
                                width: 100,
                                sortable: true };
                                
export let colCoveredEntity = {
                                colId: 'coveredEntity',
                                headerName: 'Covered Entity',
                                field: 'coveredEntity.name',
                                width: 100,
                                sortable: true
                              };


export let colLegalEntity = {
                              colId: 'legalEntity',
                              headerName: 'Legal Entity',
                              field: 'legalEntities',
                              width: 100,
                              sortable: true,
                              valueGetter: (params: any) => {
                                const legalEntities = params.data?.legalEntities;

                                if (!legalEntities) {
                                  return '';
                                }

                                // If it's already a string, return it
                                if (typeof legalEntities === 'string') {
                                  return legalEntities;
                                }

                                // If it's a single object (not an array), extract the name
                                if (typeof legalEntities === 'object' && !Array.isArray(legalEntities)) {
                                  return legalEntities.legalEntityName || legalEntities.name || '';
                                }

                                // If it's an array, join the names
                                if (Array.isArray(legalEntities)) {
                                  if (legalEntities.length === 0) {
                                    return '';
                                  }
                                  return legalEntities
                                    .map(le => {
                                      if (typeof le === 'string') return le;
                                      if (typeof le === 'object') {
                                        return le.legalEntityName || le.legalEntityData?.legalEntityName || le.name || '';
                                      }
                                      return '';
                                    })
                                    .filter(name => name)
                                    .join(', ');
                                }

                                return '';
                              }
                            };

export let colCoveredEntityNotification = {
                                            colId: 'coveredEntityNotification',
                                            headerName: 'Covered Entity Notification',
                                            field: 'coveredEntityNotification',
                                            width: 100,
                                            sortable: true,
                                            valueGetter: (params: any) => {
                                              const notification = params.data?.coveredEntityNotification;
                                              if (!notification) return '';
                                              if (typeof notification === 'string') return notification;
                                              if (typeof notification === 'object') {
                                                return notification.friendlyName || notification.fullName || notification.email || '';
                                              }
                                              return '';
                                            }
                                          };
export let colBaSignatory = {
                              colId: 'baSignatory',
                              headerName: 'BA Signatory',
                              field: 'baSignatory.fullName',
                              width: 100,
                              sortable: true
                            };

export let colCeSignatory = {
                              colId: 'ceSignatory',
                              headerName: 'CE Signatory',
                              field: 'ceSignatory.fullName',
                              width: 100,
                              sortable: true
                            };
export let colBaCoordinator = {
                                colId: 'baCoordinatory',
                                headerName: 'BA Coordinator',
                                field: 'baCoordinator.fullName',
                                width: 100,
                                sortable: true
                              };
export let colCeCoordinator = {
                                colId: 'ceCoordinator',
                                headerName: 'CE Coordinator',
                                field: 'ceCoordinator.fullName',
                                width: 100,
                                sortable: true
                              };
export let colPrimaryOwner = {
                                colId: 'primaryOwner',
                                headerName: 'Primary Owner',
                                field: 'primaryOwner.friendlyName',
                                width: 100,
                                sortable: true };
export let colSecondaryOwner = {colId: 'secondaryOwner',
                                headerName: 'Secondary Owner',
                                field: 'secondaryOwner.friendlyName',
                                width: 100,
                                sortable: true };
export let colTertiaryOwner = {colId: 'tertiaryOwner',
                                headerName: 'Tertiary Owner',
                                field: 'tertiaryOwner.friendlyName',
                                width: 100,
                                sortable: true };

export let colEffectiveDate = {
                                colId: 'effectiveDate', 
                                headerName: 'Effective Date',
                                field: 'effectiveDate',
                                width: 100,
                                sortable: true,
                                valueFormatter: dateValueFormatter
                              };

export let colExpirationDate = {colId: 'expirationDate', 
                                headerName: 'Expiration Date', 
                                field: 'expirationDate',
                                width: 100, 
                                sortable: true,
                                valueFormatter: dateValueFormatter};

export let colExecutionDate = {colId: 'executionDate', 
                                headerName: 'Execution Date',
                                field: 'executionDate',
                                width: 100, 
                                sortable: true,
                                valueFormatter: dateValueFormatter};

export let colStatus = {colId: 'status', headerName: 'Status', field: 'status',width: 100, sortable: true };

export let colSites = {
                        colId: 'sites',
                        headerName: 'Sites',
                        field: 'sites',
                        width: 100,
                        sortable: true,
                        valueGetter: (params: any) => {
                          const sites = params.data?.sites;
                          if (!sites) return '';
                          // If it's an array, join the names
                          if (Array.isArray(sites)) {
                            return sites
                              .map(site => {
                                if (typeof site === 'string') return site;
                                if (typeof site === 'object') return site.siteName || site.name || '';
                                return '';
                              })
                              .filter(name => name)
                              .join(', ');
                          }
                          // If it's a string, return as-is
                          if (typeof sites === 'string') return sites;
                          return '';
                        }
                      };

export let colVersion = {colId: 'version', headerName: 'Version', field: 'version',width: 100, sortable: true };
export let colLastReviewDate = {colId: 'lastReview', headerName: 'Last Review Date',
                      field: 'lastReviewDate',
                      width: 100,
                      sortable: true,
                      valueFormatter: dateValueFormatter};
export let colNextReviewDate = {colId: 'nextReview', headerName: 'Next Review Date',
                      field: 'nextReviewDate',
                      width: 100,
                      sortable: true,
                      valueFormatter: dateValueFormatter};
export let colDepartment = {colId: 'department', headerName: 'Departments', field: 'departments',width: 100, sortable: true };
export let colDescription = {colId: 'description', headerName: 'Description', field: 'description',width: 100, sortable: true };
export let colRiskScore = {colId: 'riskScore', headerName: 'Risk Score',
                  field: 'paymentTerms',
                  width: 100,
                  sortable: true,
                  valueFormatter: riskFormatter};
export let colMissingSignature = {colId: 'missingSignature', 
                                    headerName: 'Missing Signature', 
                                    field: 'missingSignature', 
                                    width: 50, 
                                    sortable: true };



export let allColumns = [

    colBaaNum,
    colBaaId,
    colMainDocumentName,
    colBusinessAssociateName,
    colBusinessAssociateNotification,
    colEffectiveDate,
    colExpirationDate,
    colParty,
    colDescription,
    colTypeOfService,
    colCoveredEntity,
    colLegalEntity,
    colStatus,
    colSites,
    colCoveredEntityNotification,
    colBaSignatory,
    colCeSignatory,
    colBaCoordinator,
    colPrimaryOwner,
    colSecondaryOwner,
    colTertiaryOwner,
    colCeCoordinator,
    colRiskScore,
    colVersion,
    colExecutionDate,
    colLastReviewDate,
    colNextReviewDate,
    colDepartment,
    colMissingSignature
];






export let columnSelectList = [
        {
          value: colBaaId,
          viewValue: colBaaId.headerName
        },
        {
          value: colBaaNum,
          viewValue: colBaaNum.headerName
        },
        {
          value: colMainDocumentName,
          viewValue: colMainDocumentName.headerName
        },
        {
          value: colBusinessAssociateName,
          viewValue: colBusinessAssociateName.headerName
        },
        {
          value: colBusinessAssociateNotification,
          viewValue: colBusinessAssociateNotification.headerName
        },
        {
          value: colParty,
          viewValue: colParty.headerName
        },
        {
          value: colTypeOfService,
          viewValue: colTypeOfService.headerName
        },
        {
          value: colCoveredEntity,
          viewValue: colCoveredEntity.headerName
        },
        {
          value: colLegalEntity,
          viewValue: colLegalEntity.headerName
        },
        {
          value: colCoveredEntityNotification,
          viewValue: colCoveredEntityNotification.headerName
        },
        {
          value: colBaSignatory,
          viewValue: colBaSignatory.headerName
        },
        {
          value: colCeSignatory,
          viewValue: colCeSignatory.headerName
        },
        {
          value: colBaCoordinator,
          viewValue: colBaCoordinator.headerName
        },
        {
          value: colCeCoordinator,
          viewValue: colCeCoordinator.headerName
        },
        {
          value: colPrimaryOwner,
          viewValue: colPrimaryOwner.headerName
        },
        {
          value: colSecondaryOwner,
          viewValue: colSecondaryOwner.headerName
        },
        {
          value: colTertiaryOwner,
          viewValue: colTertiaryOwner.headerName
        },
        {
          value: colEffectiveDate,
          viewValue: colEffectiveDate.headerName
        },
        {
          value: colExpirationDate,
          viewValue: colExpirationDate.headerName
        },
        {
          value: colExecutionDate,
          viewValue: colExecutionDate.headerName
        },
        {
          value: colStatus,
          viewValue: colStatus.headerName
        },
        {
          value: colSites,
          viewValue: colSites.headerName
        },
        {
          value: colVersion,
          viewValue: colVersion.headerName
        },
        {
          value: colLastReviewDate,
          viewValue: colLastReviewDate.headerName
        },
        {
          value: colNextReviewDate,
          viewValue: colNextReviewDate.headerName
        },
        {
          value: colDepartment,
          viewValue: colDepartment.headerName
        },
        {
          value: colDescription,
          viewValue: colDescription.headerName
        },
        {
          value: colRiskScore,
          viewValue: colRiskScore.headerName
        },
        {
          value: colMissingSignature,
          viewValue: colMissingSignature.headerName
        }
      ]


function riskFormatter(param) {

    // console.log('riskFormatter: ', param.data.riskScore);

    let scoreAsNumber = Number(param.data.riskScore);
    let scoreAsFloat = scoreAsNumber.toFixed(1);

    // console.log('scoreAsFloat: ', scoreAsFloat);

    if ((scoreAsFloat != undefined) &&
        (scoreAsFloat != 'NaN')) {
      return scoreAsFloat;
    } else {
      return '';
    }
  }



